<template>
	<div>
		<!-- municipe está autenticado -->
		<template v-if="municipe">
			<div class="row">
				<div class="col-md-6 col-md-offset-3">
					<v-form-cadastro-agendamento></v-form-cadastro-agendamento>
				</div>
			</div>
		</template>

		<!-- municipe não está autenticado -->
		<template v-if="showLoginForm">
			<!-- on tablets and pcs -->
			<div class="hidden-xs">
				<div class="row">
					<div class="col-md-6 col-md-offset-3">
						<div class="row">
							<div class="col-xs-6">
								<button type="button" class="btn btn-block btn-info" :class="{ active: activeComponent === 'login' }" @click="activeComponent = 'login'">LOGIN</button>
							</div>
							<div class="col-xs-6">
								<button type="button" class="btn btn-block btn-info" :class="{ active: activeComponent === 'cadastro' }" @click="activeComponent = 'cadastro'">CADASTRO</button>
							</div>
						</div>
						<div style="margin-top:15px;">
							<v-form-login :redirect-to="$route.fullPath" v-if="activeComponent === 'login'"></v-form-login>
							<v-form-cadastro-municipe v-if="activeComponent === 'cadastro'"></v-form-cadastro-municipe>
						</div>
					</div>
				</div>
			</div>

			<!-- on smartphones -->
			<div class="visible-xs">
				<div class="btn-group btn-group-justified">
					<div class="btn-group">
						<button type="button" class="btn btn-block btn-info" :class="{ active: activeComponent === 'login' }" @click="activeComponent = 'login'">LOGIN</button>
					</div>
					<div class="btn-group">
						<button type="button" class="btn btn-block btn-info" :class="{ active: activeComponent === 'cadastro' }" @click="activeComponent = 'cadastro'">CADASTRO</button>
					</div>
				</div>
				<div style="margin-top:15px;">
					<v-form-login :redirect-to="$route.fullPath" v-if="activeComponent === 'login'"></v-form-login>
					<v-form-cadastro-municipe v-if="activeComponent === 'cadastro'"></v-form-cadastro-municipe>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
	import moment from 'moment';
	import Municipe from 'models/municipe';
	import VFormLogin from 'views/permisys/login';
	import VFormCadastroMunicipe from 'views/municipe/form';
	import VFormCadastroAgendamento from 'views/agendas/form';

	export default {
		components: { VFormLogin, VFormCadastroMunicipe, VFormCadastroAgendamento },

		data() {
			return {
				municipe: '',
				activeComponent: 'login',
				showLoginForm: false
			};
		},

		async created() {
			try {
				this.municipe = await Municipe.getCurrent();
			} catch(e) {
				this.showLoginForm = true;
			}
		},

		computed: {
			data() {
				return moment(this.$route.params.data, 'DD-MM-YYYY').format('dddd, DD [de] MMMM [de] YYYY');
			}
		}
	};
</script>


// WEBPACK FOOTER //
// cadastro.vue?118d0eea